import { render } from "./ImportAmazeQuote.vue?vue&type=template&id=e0ad10de"
import script from "./ImportAmazeQuote.vue?vue&type=script&lang=js"
export * from "./ImportAmazeQuote.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Amaze-Portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__